import React from 'react';
import { Alert, Table }  from 'reactstrap';
import * as Icon from 'react-feather';
import { ConfirmModal } from '../Modals/Confirm';

export function ConfirmDeleteClassificationTypeModal(props) {
    return (
        <ConfirmModal 
            isOpen={props.isOpen}
            toggle={props.toggle} 
            handleConfirm={(e) => props.handleConfirm(props.classificationType, e)}
            title="Delete Classification Type?"
            confirmText="Yes, Delete Classification Type"
            confirmColor="danger"
            confirmIcon={Icon.Trash2}
        >
            <Alert color="warning">
                <strong>Are you sure you wish to delete the following Classification Type?</strong>
            </Alert>

            <Table bordered>
                <thead>
                    <tr>
                        <th className="col-xs-4">Name</th>
                        <th className="col-xs-4">Days Estimated for Completion</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{props.classificationType.name}</td>
                        <td>{props.classificationType.daysEstimated}</td>
                    </tr>
                </tbody>
            </Table>
        </ConfirmModal>
    );
}